import { BrowserRouter } from "react-router-dom";
import { ReviewDebugLiffReturnHandler } from "../shared/lib/ReviewDebugLiffReturnHandler";
import { SessionBootstrapProvider } from "../shared/session/SessionBootstrapProvider";
import { AppRouter } from "./router";

export function App() {
  return (
    <BrowserRouter>
      <SessionBootstrapProvider>
        <ReviewDebugLiffReturnHandler />
        <AppRouter />
      </SessionBootstrapProvider>
    </BrowserRouter>
  );
}
